"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// GTM key for env
exports.default = {
    local: 'GTM-TGBB8D2F',
    development: 'GTM-TGBB8D2F',
    staging: 'GTM-TGBB8D2F',
    production: 'GTM-N7V5KN54',
};
